export default "__VITE_ASSET__CI0ssKws__"